import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
  },
  label: {
    fontWeight: 600,
    color: '#666',
  },
  value: {
    color: '#000',
  },
}));

export default useStyles;
